import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FieldType } from './field.type';

/** @ignore */
@Component({
  selector: 'formly-template',
  template: `<div [innerHtml]="template"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyTemplateType extends FieldType {
  get template() {
    if (this.field && this.field.template !== this.innerHtml.template) {
      this.innerHtml = {
        template: this.field.template,
        content: this.props.safeHtml
          ? this.sanitizer.bypassSecurityTrustHtml(this.field.template)
          : this.field.template,
      };
    }

    return this.innerHtml.content;
  }

  private innerHtml: { content?: SafeHtml; template?: string } = {};
  constructor(private sanitizer: DomSanitizer) {
    super();
  }
}
